import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserOnline"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 15C21.1569 15 22.5 13.6569 22.5 12C22.5 10.3431 21.1569 9 19.5 9C17.8431 9 16.5 10.3431 16.5 12C16.5 13.6569 17.8431 15 19.5 15ZM3.75 6.75C3.75 3.85051 6.1005 1.5 9 1.5C11.8995 1.5 14.25 3.85051 14.25 6.75C14.25 9.6495 11.8995 12 9 12C6.1005 12 3.75 9.6495 3.75 6.75ZM9 3C11.0711 3 12.75 4.67893 12.75 6.75C12.75 8.82107 11.0711 10.5 9 10.5C6.92893 10.5 5.25 8.82107 5.25 6.75C5.25 4.67893 6.92893 3 9 3ZM16.5 22.5H15V18.75C15 16.6789 13.3211 15 11.25 15H6.75C4.67893 15 3 16.6789 3 18.75V22.5H1.5V18.75C1.5 15.8505 3.85051 13.5 6.75 13.5H11.25C14.1495 13.5 16.5 15.8505 16.5 18.75V22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserOnline.vue"]]);
